var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenueCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6406 1.26562H4.35938C3.78983 1.26562 3.32812 1.72733 3.32812 2.29688V15.7031C3.32812 16.2727 3.78983 16.7344 4.35938 16.7344H13.6406C14.2102 16.7344 14.6719 16.2727 14.6719 15.7031V2.29688C14.6719 1.72733 14.2102 1.26562 13.6406 1.26562Z",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0938 3.32812H5.90625C5.62148 3.32812 5.39062 3.55898 5.39062 3.84375V5.90625C5.39062 6.19102 5.62148 6.42188 5.90625 6.42188H12.0938C12.3785 6.42188 12.6094 6.19102 12.6094 5.90625V3.84375C12.6094 3.55898 12.3785 3.32812 12.0938 3.32812Z",
    stroke: "#A1A4A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 9.51562C6.02167 9.51562 5.90625 9.40019 5.90625 9.25781C5.90625 9.11543 6.02167 9 6.16406 9",
    stroke: "#A1A4A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 9.51562C6.30645 9.51562 6.42188 9.40019 6.42188 9.25781C6.42188 9.11543 6.30645 9 6.16406 9",
    stroke: "#A1A4A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 12.0938C6.02167 12.0938 5.90625 11.9783 5.90625 11.8359C5.90625 11.6936 6.02167 11.5781 6.16406 11.5781",
    stroke: "#A1A4A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 12.0938C6.30645 12.0938 6.42188 11.9783 6.42188 11.8359C6.42188 11.6936 6.30645 11.5781 6.16406 11.5781",
    stroke: "#A1A4A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 14.6719C6.02167 14.6719 5.90625 14.5564 5.90625 14.4141C5.90625 14.2717 6.02167 14.1562 6.16406 14.1562",
    stroke: "#A1A4A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 14.6719C6.30645 14.6719 6.42188 14.5564 6.42188 14.4141C6.42188 14.2717 6.30645 14.1562 6.16406 14.1562",
    stroke: "#A1A4A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10718 9.51562C8.9648 9.51562 8.84937 9.40019 8.84937 9.25781C8.84937 9.11543 8.9648 9 9.10718 9",
    stroke: "#A1A4A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10718 9.51562C9.24956 9.51562 9.36499 9.40019 9.36499 9.25781C9.36499 9.11543 9.24956 9 9.10718 9",
    stroke: "#A1A4A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10718 12.0938C8.9648 12.0938 8.84937 11.9783 8.84937 11.8359C8.84937 11.6936 8.9648 11.5781 9.10718 11.5781",
    stroke: "#A1A4A6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10718 12.0938C9.24956 12.0938 9.36499 11.9783 9.36499 11.8359C9.36499 11.6936 9.24956 11.5781 9.10718 11.5781",
    stroke: "#A1A4A6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10718 14.6719C8.9648 14.6719 8.84937 14.5564 8.84937 14.4141C8.84937 14.2717 8.9648 14.1562 9.10718 14.1562",
    stroke: "#A1A4A6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10718 14.6719C9.24956 14.6719 9.36499 14.5564 9.36499 14.4141C9.36499 14.2717 9.24956 14.1562 9.10718 14.1562",
    stroke: "#A1A4A6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8359 9.51562C11.6936 9.51562 11.5781 9.40019 11.5781 9.25781C11.5781 9.11543 11.6936 9 11.8359 9",
    stroke: "#A1A4A6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8359 9.51562C11.9783 9.51562 12.0938 9.40019 12.0938 9.25781C12.0938 9.11543 11.9783 9 11.8359 9",
    stroke: "#A1A4A6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8359 12.0938C11.6936 12.0938 11.5781 11.9783 11.5781 11.8359C11.5781 11.6936 11.6936 11.5781 11.8359 11.5781",
    stroke: "#A1A4A6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8359 12.0938C11.9783 12.0938 12.0938 11.9783 12.0938 11.8359C12.0938 11.6936 11.9783 11.5781 11.8359 11.5781",
    stroke: "#A1A4A6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8359 14.6719C11.6936 14.6719 11.5781 14.5564 11.5781 14.4141C11.5781 14.2717 11.6936 14.1562 11.8359 14.1562",
    stroke: "#A1A4A6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8359 14.6719C11.9783 14.6719 12.0938 14.5564 12.0938 14.4141C12.0938 14.2717 11.9783 14.1562 11.8359 14.1562",
    stroke: "#A1A4A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueCalculator);
export default __webpack_public_path__ + "static/media/Revenue Calculator.e2fc97091fb056264e0c9d8d6bb2d0bc.svg";
export { ForwardRef as ReactComponent };